module.exports = __webpack_public_path__ + "static/img/pin-off.ed850ab8.svg";